import React from 'react';
import BreadcrumbsUI5 from "../../../../../gd-components/breadcrumbs/breadcrumbs-ui5";
import GDProjectName from "../../../../../gd-ui/project-name/project-name";
import {FieldViewProps} from "../../../../render/view";
import ProjectIcon from "../../../../../gd-components/icons/project/project-icon-ui5"

type Options = {
    fullPath?       : boolean
    showIcon?       : boolean
    colorize?       : boolean
    maxParents?     : number
}

export enum FieldProject_ViewType {
    PROPERTY    = 'property',
    FULL_PATH   = 'full-path',
}

type Props = FieldViewProps & {
    options?            : Options,
    viewType?           : FieldProject_ViewType | null
};


export default function FieldProject_View(props:Props) {

    const value = props.field.getViewValue(props.model)

    const configOptions = props.configOptions || props.options

    if (!value) {
        return (
            <div className={Classes("ui5-txt-less-important txt-truncate", props.className)}>
                No parent
            </div>
        )
    }

    switch (props.viewType) {

        case FieldProject_ViewType.FULL_PATH: {

            const showIcon   = _.get(configOptions, 'showIcon', false)
            const maxParents = _.get(props.params, 'maxParents', 3)
            const colorize   = _.get(configOptions, 'colorize', false)

            // use ui5-prop gray m-r-10 in class to make it look like property

            return <BreadcrumbsUI5 className    = {Classes("ui5-prop", "gray", props.className)}
                                   projectId    = {value}
                                   maxParents   = {maxParents}
                                   showIcon     = {showIcon}
                                   colorize     = {colorize}
                                   disabled     = {true}/>
        }
        case FieldProject_ViewType.PROPERTY: {
            const showIcon          = _.get(configOptions,'showIcon', false)
            // const colorize          = _.get(props,'options.colorize', false)

            return <GDProjectName className     = {props.className}
                                  projectId     = {value}
                                  type          = {showIcon ? 'with-icon' : 'ui5-prop'}
                                  hintFullPath  = {true} />
        }

        default:
            const showIcon          = _.get(configOptions,'showIcon', false)
            const projectName = gd.session.projects.get(value)?.name
            const icon = showIcon ? <ProjectIcon className="m-r-5" projectId={value} colorize={false} /> : null

            const classes = Classes('flex-row-left-center', props.className)

            return <span className={classes}>{icon}{projectName}</span>
    }


}
